import { getGioiTinh } from '../../constant/gioiTinh'
import { DDMMYYToDate } from '../../utils/date'

/* eslint-disable max-lines-per-function */
const tempChungNhan = (data) => {
  const now = new Date()
  let ngayTotNghiep = new Date()
  if (data.ngayTotNghiep) {
    ngayTotNghiep = DDMMYYToDate(data.ngayTotNghiep)
  }
  return `
<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">
<html>

<head>
	<link rel="stylesheet" type="text/css" href="style.css" />
</head>

<body>
	<div style="position:absolute;top:0.51in;left:1.77in;width:4.85in;line-height:0.25in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">PHÒNG GIÁO
			DỤC VÀ ĐÀO TẠO HUYỆN ${data.donVi ? data.donVi.toUpperCase() : ''}</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br />
		<DIV style="position:relative; left:1.00in;"><span
				style="font-style:normal;font-weight:bold;font-size:13pt;font-family:Times New Roman;color:#000000; text-decoration: underline;">${
          data.truong.name
        }</span><span
				style="font-style:normal;font-weight:bold;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
		</DIV>
	</div>
	<div style="position:absolute;top:0.51in;left:7.53in;width:4.31in;line-height:0.25in;"><span
			style="font-style:normal;font-weight:bold;font-size:13pt;font-family:Times New Roman;color:#000000">CỘNG HÒA XÃ
			HỘI CHỦ NGHĨA VIỆT NAM</span><span
			style="font-style:normal;font-weight:bold;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br />
		<DIV style="position:relative; left:0.82in;"><span
				style="font-style:normal;font-weight:bold;font-size:13pt;font-family:Times New Roman;color:#000000; text-decoration: underline;">Độc
				lập - Tự do - Hạnh phúc</span><span
				style="font-style:normal;font-weight:bold;font-size:13pt;font-family:Times New Roman;color:#000000">
			</span><br /></SPAN></DIV>
	</div>
	<div style="position:absolute;top:1.23in;left:3.20in;width:6.58in;line-height:0.34in;"><span
			style="font-style:normal;font-weight:bold;font-size:16pt;font-family:Times New Roman;color:#000000">GIẤY CHỨNG
			NHẬN TỐT NGHIỆP TRUNG HỌC CƠ SỞ</span><span
			style="font-style:normal;font-weight:bold;font-size:16pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
	</div>
	<div style="position:absolute;top:1.50in;left:5.66in;width:1.66in;line-height:0.34in;"><span
			style="font-style:normal;font-weight:bold;font-size:16pt;font-family:Times New Roman;color:#000000">(TẠM
			THỜI)</span><span
			style="font-style:normal;font-weight:bold;font-size:16pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
	</div>
	<div style="position:absolute;top:1.82in;left:0.90in;width:3.94in;line-height:0.27in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">Chứng nhận:
		</span></SPAN><br /></div>
	<div style="position:absolute;top:1.82in;left:0.90in;width:3.94in;line-height:0.27in;">
		<DIV style="position:relative; left:1.59in;"><span
				style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">${
          data.tenHocSinh
        }</span><span
				style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
		</DIV>
	</div>
	<div style="position:absolute;top:1.82in;left:7.35in;width:0.96in;line-height:0.28in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">Giới
			tính:</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">Nơi sinh:
		</span><span style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">
		</span><br /></SPAN></div>
	<div style="position:absolute;top:1.82in;left:8.47in;width:0.43in;line-height:0.22in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">${getGioiTinh(
        data.gioiTinh,
      )}</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000"> </span><br /></SPAN>
	</div>
	<div style="position:absolute;top:2.12in;left:0.90in;width:0.90in;line-height:0.22in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">Sinh ngày:</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000"> </span><br /></SPAN>
	</div>
	<div style="position:absolute;top:2.12in;left:2.48in;width:1.29in;line-height:0.22in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">${
        data.ngaySinh
      }
		</span><span style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">
		</span><br /></SPAN></div>
	<div style="position:absolute;top:2.11in;left:7.35in;width:2.91in;line-height:0.27in;">
		<DIV style="position:relative; left:1.13in;"><span
				style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">${
          data.noiSinh
        }</span><span
				style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
		</DIV>
	</div>
	<div style="position:absolute;top:2.39in;left:0.90in;width:1.21in;line-height:0.27in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">Lớp:
		</span><span style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">
		</span><br /></SPAN></div>
	<div style="position:absolute;top:2.39in;left:2.48in;width:0.29in;line-height:0.22in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">${
        data.noiCuTru
      }</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000"> </span><br /></SPAN>
	</div>
	<div style="position:absolute;top:2.39in;left:7.35in;width:2.91in;line-height:0.27in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">${
        data.truong.name
      }
			TH&amp;THCS Hồng Lĩnh</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
	</div>
	<div style="position:absolute;top:2.67in;left:0.90in;width:8.39in;line-height:0.27in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">Hiện cư trú
			tại: </span></SPAN><br /></div>
	<div style="position:absolute;top:2.67in;left:0.90in;width:8.39in;line-height:0.24in;">
		<DIV style="position:relative; left:1.59in;"><span
				style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">${
          data.noiCuTru
        }</span><span
				style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
		</DIV><span style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">Đã
			được công nhận tốt nghiệp trung học cơ sở tại hội đồng xét tốt nghiệp ${
        data.truong.name
      }</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">.</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000"> </span><br /><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">Ngày ${ngayTotNghiep.getDate()} tháng
			${ngayTotNghiep.getMonth()}</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"> năm
		</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">${ngayTotNghiep.getFullYear()}</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000"> </span><br /></SPAN>
	</div>
	<div style="position:absolute;top:3.51in;left:0.90in;width:3.39in;line-height:0.25in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">Xếp loại tốt
			nghiệp: ${data.xepLoai}</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN><span
			style="font-style:italic;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">Ghi chú:
			Giấy này chỉ có giá trị trong một</span><span
			style="font-style:italic;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">
		</span><br /><span
			style="font-style:italic;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">năm kể từ
			ngày kí</span><span
			style="font-style:italic;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
	</div>
	<div style="position:absolute;top:3.79in;left:8.42in;width:2.39in;line-height:0.22in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">..., ngày ${now.getDate()} tháng
			${now.getMonth()}</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"> năm
		</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000">${now.getFullYear()}</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times;color:#000000"> </span><br /></SPAN>
	</div>
	<div style="position:absolute;top:4.01in;left:8.76in;width:1.85in;line-height:0.27in;"><span
			style="font-style:normal;font-weight:bold;font-size:13pt;font-family:Times New Roman;color:#000000">TRƯỞNG
			PHÒNG</span><span
			style="font-style:normal;font-weight:bold;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
	</div>
	<div style="position:absolute;top:4.22in;left:8.46in;width:2.46in;line-height:0.27in;"><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000">(họ tên, chữ
			ký và đóng dấu)</span><span
			style="font-style:normal;font-weight:normal;font-size:13pt;font-family:Times New Roman;color:#000000"></span><br /></SPAN>
	</div>
</body>

</html>
`
}
export default tempChungNhan
